import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { BillingService } from './billing.service';
import {
  BillingAction,
  GET_BILLING_INFORMATION,
  GetBillingInformationFailureAction,
  GetBillingInformationSuccessAction,
  UPDATE_BILLING_INFORMATION,
  UpdateBillingInformationAction,
  UpdateBillingInformationFailureAction,
  UpdateBillingInformationSuccessAction
} from './billing.action';
import { BillingInformation } from './billing';

@Injectable()
export class BillingEffects {
  @Effect()
  getBillingInformation$: Observable<BillingAction> = this.actions$.pipe(
    ofType(GET_BILLING_INFORMATION),
    switchMap(() =>
      this.billingService
        .getBillingInformation()
        .pipe(
          map((response: BillingInformation) => new GetBillingInformationSuccessAction(response)),
          catchError(error => of(new GetBillingInformationFailureAction(error)))
        )
    )
  );

  @Effect()
  updateBillingInformation$: Observable<BillingAction> = this.actions$.pipe(
    ofType(UPDATE_BILLING_INFORMATION),
    map((action: UpdateBillingInformationAction) => action.payload),
    switchMap((payload: BillingInformation) =>
      this.billingService
        .updateBillingInformation(payload)
        .pipe(
          map(() => new UpdateBillingInformationSuccessAction(payload)),
          catchError(error => of(new UpdateBillingInformationFailureAction(error)))
        )
    )
  );

  constructor(private actions$: Actions, private billingService: BillingService) {}
}
